import { Component, ViewChild, AfterViewChecked } from '@angular/core';
import _ from 'lodash';
import { DocumentsGridComponent } from '@common/components/documents-grid/documents-grid.component';
import { AppGridComponent } from '@common/components/app-grid/app-grid.component';


@Component({
    selector: 'app-vessel-visit-documents-grid',
    templateUrl: './vessel-visit-documents-grid.component.html',
    styleUrls: ['./vessel-visit-documents-grid.component.scss']
})
export class VesselVisitDocumentsGridComponent extends DocumentsGridComponent {

}
